import { render, staticRenderFns } from "./BusinessKind.vue?vue&type=template&id=ef28cbea&scoped=true&"
import script from "./BusinessKind.vue?vue&type=script&lang=js&"
export * from "./BusinessKind.vue?vue&type=script&lang=js&"
import style0 from "./BusinessKind.vue?vue&type=style&index=0&id=ef28cbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef28cbea",
  null
  
)

export default component.exports